import {
    type SendContactFormRequestType,
    type SendContactFormResponseType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const SendContactForm = async (params: SendContactFormRequestType): Promise<SendContactFormResponseType> => {
    return await axios(`${SERVER_ADDRESS}/front/sendContactForm`, {
        method: "POST",
        headers: getHeaders(),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default SendContactForm;
